<template>
	<div>
		<p>{{ $tc('components.colorSelectorTitle') }}</p>
		<div class="mt-25 colors-wrap">
			<div
				v-for="backgroundColor in colors"
				:key="backgroundColor"
				:class="{ active: backgroundColor === value }"
				:style="{ backgroundColor }"
				class="color-square"
				@click="$emit('input', backgroundColor)"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ColorSelector',
	props: {
		value: {
			type: String,
			default: '#FFFFFF'
		}
	},
	data () {
		return {
			colors: [
				'#FD0D1B', '#FD7722', '#FFE138', '#CDF332', '#67DB28', '#1BB756', '#28F2B5', '#179CB7', '#1067DB',
				'#081DDB', '#010766', '#9C19B7', '#B7159C', '#F3126C', '#66032F', '#3F011D', '#000000', '#FFFFFF'
			]
		}
	}
}
</script>

<style lang="scss">
	.colors-wrap {
		display: flex;
		flex-wrap: wrap;
		max-width: 320px;

		.color-square {
			margin: 0 10px 10px 0;
			height: 25px;
			width: 25px;
			cursor: pointer;
			transition: 0.4s;

			&:last-child {
				border: 1px solid black;
			}

			&.active {
				transform: scale(1.25);
			}
		}
	}
</style>
